import { useEffect, useRef, useCallback } from "react";

const spokenDist = (m) => (m < 1000 ? `${Math.max(50, Math.round(m / 50) * 50)} meters` : `${(m / 1000).toFixed(m < 10000 ? 1 : 0)} kilometers`);
const lower = (t) => t.charAt(0).toLowerCase() + t.slice(1);

export function useVoice(nav, on) {
  const said = useRef({});
  const speak = useCallback((text, force) => {
    if ((!on && !force) || !window.speechSynthesis) return;
    const u = new SpeechSynthesisUtterance(text);
    u.lang = navigator.language || "en-US";
    window.speechSynthesis.cancel();
    window.speechSynthesis.speak(u);
  }, [on]);
  const { route, progress, status, dest } = nav;

  useEffect(() => {
    if (!on) window.speechSynthesis?.cancel();
  }, [on]);

  useEffect(() => {
    if (!route || !progress) return;
    const st = route.steps[progress.next];
    if (!st) return;
    const k = `${route.generated_at}:${progress.next}`;
    const d = progress.to_next_m;
    const stage = d < 120 ? "now" : d < 600 ? "soon" : "far";
    if (said.current[`${k}:${stage}`]) return;
    said.current[`${k}:${stage}`] = true;
    if (stage === "far" && (said.current[`${k}:soon`] || said.current[`${k}:now`])) return;
    speak(stage === "now" || st.dir === "arrive" && d < 120 ? st.text : `In ${spokenDist(d)}, ${lower(st.text)}`);
  }, [route, progress, speak]);

  useEffect(() => {
    if (status.startsWith("Rerouted")) speak("Rerouting.");
    else if (status === "You have arrived.") speak(`You have arrived${dest?.name ? ` at ${dest.name}` : ""}.`);
  }, [status, dest, speak]);

  useEffect(() => () => window.speechSynthesis?.cancel(), []);
  return speak;
}
